<ng-container *transloco="let t">
@for (entry of listEntries; track entry; let i = $index) {
  @if (entry.kind === 'standalone') {
    <asset-item
      [asset]="entry.item"
      class="w-100"
      (editClicked)="onAssetEditClicked($event)"
      (deleteClicked)="onAssetDeleted($event)"
    ></asset-item>
  }
  @if (entry.kind === 'group') {
    <div class="rounded border border-primary border-dashed mb-4 p-6">
      <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
        <span class="fs-5 fw-bolder text-gray-800 d-flex align-items-center">
          <span class="svg-icon svg-icon-2x svg-icon-primary me-4" style="padding-bottom: 2px;">
            <stockholm-bank-svg-icon></stockholm-bank-svg-icon>
          </span>
          {{ entry.depository }}
        </span>
        <span class="fs-6 fw-bolder text-gray-700">
          {{ t('wizard.assets.valueLabel') }} {{ entry.groupTotal | currency }}
        </span>
      </div>
      @for (child of entry.children; track child.id) {
        <asset-item
          [asset]="child"
          [insideGroup]="true"
          class="w-100"
          (editClicked)="onAssetEditClicked($event)"
          (deleteClicked)="onAssetDeleted($event)"
        ></asset-item>
      }
      <div class="d-flex justify-content-end mt-2">
        <button type="button" class="btn btn-sm btn-light-primary"
          (click)="addAtInstitutionClicked.emit(entry.depository)">
          <i class="bi bi-plus-lg me-1"></i>{{ t('wizard.assets.addAnotherAtThisInstitution') }}
        </button>
      </div>
    </div>
  }
}
@if (assetItems.length > 0) {
  <div class="w-100 mb-2 p-2">
    <span style="text-align: right" class="text-dark fw-bolder d-block fs-5"
      >{{ t('wizard.assets.totalAssets') }} {{ totalAssets | currency }}</span
    >
  </div>
}
</ng-container>
